module.exports = "<h5>Beneficio</h5>"